export const ReportComponentType = {
  SECTION: 1,
  CHART: 2,
}
